import React from "react";
import { graphql, useStaticQuery } from "gatsby";

import "../../scss/main.scss";
import BrochureRequestPanel from "../components/BrochureRequestPanel";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Seo from "../components/Seo";

const guideHighlights = [
	"How fully managed live-in care works",
	"What to consider when comparing care options",
	"Questions that can make the next step clearer",
];

export default function RequestABrochure() {
	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						appConfig {
							gtmContainerId
						}
					}
				}
			}
		`
	);

	const {
		siteMetadata: {
			appConfig: { gtmContainerId },
		},
	} = site;

	return (
		<div className="container edyn-brochure-page">
			<Seo
				title="Request a Live-in Care Guide | Edyn Care"
				description="Request Edyn's live-in care guide for clear information about arranging care at home, how the service works and what your family can expect."
				path="/request-a-brochure/"
			/>

			<Header />

			<main id="content-start">
				<section className="brochure-page-hero">
					<div className="site-shell brochure-page-hero__panel">
						<div className="brochure-page-hero__copy">
							<p className="eyebrow">A helpful first step</p>
							<h1>Care is a big decision. Start with a clearer picture.</h1>
							<p>
								Our free guide gives you a calm, practical introduction to
								live-in care, so you can explore the options in your own time.
							</p>
							<div className="brochure-page-hero__note">
								<span aria-hidden="true">PDF</span>
								<p>
									<strong>Delivered by email.</strong>
									No obligation and no pressure to decide today.
								</p>
							</div>
						</div>

						<div className="brochure-page-hero__visual">
							<div className="brochure-page-hero__guide">
								<img
									src="/assets/marketing-site/images/live-in-form.png"
									alt="Cover of Edyn's Live-in Care Guide"
								/>
							</div>
							<p>
								A practical guide for you and the people close to you, ready to
								read whenever it suits you.
							</p>
						</div>
					</div>
				</section>

				<section className="brochure-page-form section-space">
					<div className="site-shell">
						<BrochureRequestPanel
							className="london-brochure__panel brochure-page__panel"
							gtmContainerId={gtmContainerId}
							headingLevel="h2"
							heading="Send me the Live-in guide"
							description="Tell us a little about your situation and we will email the guide straight to you."
							includeCareFor
							editorialIntro={
								<div className="london-brochure__intro">
									<p className="eyebrow eyebrow--light">
										Your free Live-in Care Guide
									</p>
									<h2>A clearer way to plan care at home.</h2>
									<p>
										Read it in your own time, share it with family and use it to
										make the next conversation more useful.
									</p>
									<ul>
										{guideHighlights.map((highlight) => (
											<li key={highlight}>{highlight}</li>
										))}
									</ul>
									<div className="london-brochure__note">
										<span aria-hidden="true">PDF</span>
										<p>
											<strong>Free and delivered by email.</strong>
											No obligation and no pressure to decide today.
										</p>
									</div>
								</div>
							}
						/>
					</div>
				</section>
			</main>

			<Footer includeCTA={false} />
		</div>
	);
}
